var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/folder-favorite"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder-favorite"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.4996 17.2426L14.7246 19.8792C14.8746 20.0076 15.1121 20.0076 15.2621 19.8792L18.4871 17.2426C19.3246 16.5542 19.4371 15.3876 18.7371 14.5709C18.0371 13.7542 16.7621 13.6026 15.8746 14.2326L14.9996 14.8626L14.1121 14.2442C13.2121 13.6142 11.9496 13.7659 11.2496 14.5826C10.5496 15.3876 10.6621 16.5659 11.4996 17.2426Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27.5 12.832V19.832C27.5 24.4987 26.25 25.6654 21.25 25.6654H8.75C3.75 25.6654 2.5 24.4987 2.5 19.832V8.16536C2.5 3.4987 3.75 2.33203 8.75 2.33203H10.625C12.5 2.33203 12.9125 2.84536 13.625 3.73203L15.5 6.06536C15.975 6.6487 16.25 6.9987 17.5 6.9987H21.25C26.25 6.9987 27.5 8.16536 27.5 12.832Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.cd7446a80474e437b01f8940eef2eabf.svg";
export { ForwardRef as ReactComponent };